import { render } from "./PropertyAnalysis.vue?vue&type=template&id=463b213c&scoped=true"
import script from "./PropertyAnalysis.vue?vue&type=script&lang=js"
export * from "./PropertyAnalysis.vue?vue&type=script&lang=js"

import "./PropertyAnalysis.vue?vue&type=style&index=0&id=463b213c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-463b213c"]])

export default __exports__